import b_ from 'b_';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FixedSizeList } from 'react-window';
import './ConsoleFragments.css';

const block = b_.lock('ConsoleList');

export default class ConsoleVirtualList extends Component {
    static propTypes = {
        title: PropTypes.node,
        titleClassName: PropTypes.string,
        height: PropTypes.number,
        itemSize: PropTypes.number,
        itemCount: PropTypes.number,
        focusedItemIndex: PropTypes.number,
    };

    ItemRenderer = ({ index, style }) => <div
        className={block('Item', { focused: index === this.props.focusedItemIndex })}
        style={style}
    >{React.createElement(this.props.children, { index })}</div>;

    Container = ({ ...props }) => <div className={block('List')} {...props} />;

    render() {
        const { className, title, titleClassName } = this.props;
        return <div className={cn(block(), className)}>
            <div className={cn(block('Head'), titleClassName)}>{title}</div>
            <FixedSizeList
                className={block('ListWrapper')}
                height={this.props.height}
                itemSize={this.props.itemSize}
                itemCount={this.props.itemCount}
                innerElementType={this.Container}
            >{this.ItemRenderer}</FixedSizeList>
        </div>;
    }
}
